/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import AppContext from "../Utils/appContext";
import { useNavigate } from "react-router-dom";
import { extractIdFromGid } from "../Utils/categories-divide";
import ProductAutoScroll from "./ProductAutoScroll";

function SimilarProduct({ recommendedProducts }) {
  const navigate = useNavigate();
  const { showPrice } = React.useContext(AppContext);

  const goToProduct = (id) => {
    const productId = extractIdFromGid(id);
    navigate("/product?productId=" + productId);
  };

  return (
    <ProductAutoScroll
      products={recommendedProducts || []}
      showPrice={showPrice}
      onProductClick={goToProduct}
      getImageSrc={(product) => product?.images?.nodes?.[0]?.url}
      getImageAlt={(product) => product?.title || ""}
      titleId="estimate-h4-smaller"
      showWishlist
      wishlistSource="RECOMMENDED"
    />
  );
}

export default SimilarProduct;
